<div ngbDropdown placement="bottom-right" role="menu" [autoClose]="true" #dropdown="ngbDropdown">
  <button ngbDropdownToggle type="button" class="dropdown-toggle">
    <rx-icon name="menu-action" class="dropdown-icon" [rotate]="45" role="button" fill="text-color" />
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <span class="dropdown-menu-arrow"></span>

    <!--Method A using class "dropdown-item" as selector -->
    <ng-content select=".dropdown-item"></ng-content>

    <!--Method B using list of items that are keyboard accessible -->
    @for (option of options(); track option.id) {
      <button ngbDropdownItem class="dropdown-item" (click)="onItemClick.emit(option)" [disabled]="option.disabled">
        @if (option.icon) {
          <rx-icon [name]="option.icon" class="mr-1" />
        }
        {{ option.label }}
      </button>
    }
  </div>
</div>
